import { type QueryFunctionContext, useQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';

import useTranslation from '@hooks/useTranslation';

import { apiClient } from '@services/apiClient';

interface IAvailableEquipmentTypesKeys {
  locationIds: Array<number>;
}

export const availableEquipmentTypesKey = (keys: IAvailableEquipmentTypesKeys) => [
  'availableEquipmentTypes',
  keys?.locationIds,
];

export const availableEquipmentTypesFn = ({
  queryKey,
}: QueryFunctionContext<ReturnType<typeof availableEquipmentTypesKey>>) =>
  apiClient.get(`${APP_API_URL}get-available-waites-equipment-types`, {
    params: { locationIds: queryKey[1] },
  });

const availableEquipmentTypesSelect = (
  t: (text: string) => string,
  availableWaitesEquipmentTypes: Array<string>,
) => {
  const availableTypesList: Array<{ id: string; name: string }> = [];
  let hasSensorItem = false;

  availableWaitesEquipmentTypes.forEach((type) => {
    if (type === 'sensor' || type === 'mote') {
      if (!hasSensorItem) {
        availableTypesList.push({ id: 'sensor', name: t('Tethered Sensor/Sensor Mote') });
        hasSensorItem = true;
      }
    } else {
      availableTypesList.push({ id: type, name: t(type.charAt(0).toUpperCase() + type.slice(1)) });
    }
  });

  return availableTypesList;
};

export const useAvailableEquipmentTypesQuery = (keys: IAvailableEquipmentTypesKeys) => {
  const { t } = useTranslation();

  return useQuery({
    queryKey: availableEquipmentTypesKey(keys),
    queryFn: availableEquipmentTypesFn,
    select: ({ data }: AxiosResponse<{ available_waites_equipment_types: Array<string> }>) =>
      availableEquipmentTypesSelect(t, data.available_waites_equipment_types),
  });
};
